import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../../core/util/apifeatures';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { CRBTUIComponentProps, CRBTUIComponent } from '../../crbt/crbtuicomponent';
import { ShowMoreFeaturedCategoryCSSStyleImpl } from './showmorefeaturedcategorycss';
import { ShowMoreFeaturedCategoryViewImpl } from './showmorefeaturedcategoryview';
import { ShowMoreFeaturedCategoryToneViewModelImpl } from './showmorefeaturedcategoryviewmodel';
import { FeaturedCategoryAPIModel, FeaturedCategoryAPIModelImpl } from '../featuredcategoryapimodel';
import { FeaturedCategoryDto } from 'src/com/sixdee/crbtportal/core/dto/featuredcategory/featuredcategorydto';





export interface ShowMoreFeaturedCategoryComponentProps extends CRBTUIComponentProps
{
   title:string;
   identifier: string;
}

export interface ShowMoreFeaturedCategoryComponentHandler extends UIComponentHandler
{
    onDataNotLoaded(isNotLoaded: boolean): void;
}
export interface  ShowMoreFeaturedCategoryComponentState extends UIComponentState
{
    isDataNotLoaded: boolean;
}

export class ShowMoreFeaturedCategoryComponent extends CRBTUIComponent<ShowMoreFeaturedCategoryComponentProps, ShowMoreFeaturedCategoryComponentState> 
implements ShowMoreFeaturedCategoryComponentHandler
{
    private ShowMoreFeaturedCategoryViewModel: ShowMoreFeaturedCategoryToneViewModelImpl;

    constructor(props: ShowMoreFeaturedCategoryComponentProps)
    {
        super(props);
        this.ShowMoreFeaturedCategoryViewModel = new ShowMoreFeaturedCategoryToneViewModelImpl(this.props.context, "40px", 
        this.props.context.getResources().getString(Strings.search_results_for));
        this.ShowMoreFeaturedCategoryViewModel.setListDatas([]);
        this.state ={isDataNotLoaded:false};
    }
     onDataNotLoaded(isNotLoaded: boolean): void 
     {
        this.setState({isDataNotLoaded: isNotLoaded});
     }

     componentDidMount()
       {
        (this.getView() as ShowMoreFeaturedCategoryViewImpl).showLoader();
        this.getAPIModel().getFeaturedCategoriesForJustForYou(this.props.identifier, this.props.title);
       }

       componentWillReceiveProps(nextProps: ShowMoreFeaturedCategoryComponentProps)
       {
        (this.getView() as ShowMoreFeaturedCategoryViewImpl).showLoader();
         (this.getView() as ShowMoreFeaturedCategoryViewImpl).setListOfDatas([]);
         
           this.setState({isDataNotLoaded: false});
          
           this.getAPIModel().getFeaturedCategoriesForJustForYou(this.props.identifier, this.props.title);
       }
   
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ShowMoreFeaturedCategoryViewImpl(this.ShowMoreFeaturedCategoryViewModel, applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ShowMoreFeaturedCategoryCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new FeaturedCategoryAPIModelImpl(applicationContext, apiModelHandler);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("------success");
        (this.getView() as ShowMoreFeaturedCategoryViewImpl).dismissLoader();
        this.ShowMoreFeaturedCategoryViewModel.setListDatas((data as FeaturedCategoryDto).getListOfTones());
        this.setState({ isDataNotLoaded:   this.ShowMoreFeaturedCategoryViewModel.getListOfDatas().length > 0 ? false :  true});

        window.scroll(0,0);
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as ShowMoreFeaturedCategoryViewImpl).dismissLoader();
        this.ShowMoreFeaturedCategoryViewModel.getListOfDatas().length = 0;
        this.setState({ isDataNotLoaded: true});
    
        window.scroll(0,0);
        }

    getAPIModel(): FeaturedCategoryAPIModel
    {
        return (super.getAPIModel() as FeaturedCategoryAPIModel);
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/showmorefeaturedcategory/showmorefeaturedcategorycomponent.tsx